<ng-container [ngSwitch]="appVersion">
    <ng-template [ngSwitchCase]="appVersions.PORTAL">
        <app-sidebar-portal class="aside-inner"></app-sidebar-portal>
    </ng-template>
    <ng-template ngSwitchDefault>
        <app-sidebar class="aside-inner"></app-sidebar>
    </ng-template>
</ng-container>